import { BorrowerService } from 'ng2-app/modules/borrower/models/borrower/borrower.service';
import { BorrowerStore } from '../models/borrower/borrower.store';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import * as _ from 'lodash';
import { catchError, switchMap } from 'rxjs/operators';
import { Borrower } from '../models/borrower/borrower.model';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { ApiAuthOnlyHttpClient } from 'app/http/clients/api-auth-only';
import { Store } from '@ngxs/store';
import { GetBorrower } from 'app/store/borrower/borrower/borrower.actions';

@Injectable()
export class WorkflowService {
    /**
     * Statuses, in workflow order
     *
     * @type Array<string>
     */
    static statuses: Array<string> = [
        'inContact',
        'appReady',
        'dealInProgress'
    ];

    constructor(
        private http: ApiAuthOnlyHttpClient,
        private borrowerStore: BorrowerStore,
        private borrowerService: BorrowerService,
        private store: Store,
    ) { }

    nextStatus(currentStatus) {
        return _(WorkflowService.statuses)
            .dropWhile(status => status !== currentStatus)
            .drop(1)
            .head();
    }

    prevStatus(currentStatus) {
        return _(WorkflowService.statuses)
            .dropRightWhile(status => status !== currentStatus)
            .dropRight(1)
            .last();
    }

    sendToFundingDesk(borrower: Borrower | number): Observable<Object> {
        const borrowerId = typeof borrower === 'number' ? borrower : borrower.id;
        const url = `/api/borrower/${borrowerId}/send-to-funding-desk`;

        const injectBorrowerFromResponse = (body: any | null) => {
            // If response contains borrower, inject borrower
            if (body.data) {
                this.borrowerStore.inject(this.borrowerService.createFromResponseData(body.data));
                this.store.dispatch(new GetBorrower(borrowerId, true)); // also update BorrowerState to ensure reactivity
            }
        };

        const handleRequestError = (response: HttpErrorResponse | HttpResponse<any>) => {
            let body;
            if (response instanceof HttpErrorResponse) {
                body = response.error;
            } else {
                body = response.body;
            }
            injectBorrowerFromResponse(body);
            const errors = body.errors || [{ message: 'Error sending to funding desk.' }];
            return throwError(() => errors);
        };

        return this.http.put(url, {}).pipe(
            catchError((errorResponse: HttpErrorResponse) => handleRequestError(errorResponse)),
            switchMap((body) => {
                const response = { success: true, borrowerName: body['data']['name'] ?? false };
                injectBorrowerFromResponse(body);
                return of(response);
            })
        );
    }
}
